import XMarkIcon from "@heroicons/react/20/solid/XMarkIcon";
import CheckIcon from "@heroicons/react/20/solid/CheckIcon";
import { Switch as HeadlessSwitch } from "@headlessui/react";

export default function ToggleSwitch({
  checked,
  iconRequired = true,
  disabled = false,
  ariaLabel = "Use setting",
  onChange,
}: {
  checked: boolean;
  iconRequired?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
  onChange?: (checked: boolean) => void;
}) {
  return (
    <HeadlessSwitch
      checked={checked}
      disabled={disabled}
      onChange={onChange || (() => null)}
      className={`${checked ? "bg-themed-accent" : "bg-themed-muted"} ${
        disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"
      }
          relative inline-flex h-[18px] w-[32px] shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-themed-ring focus-visible:ring-opacity-75`}
    >
      <span className="sr-only">{ariaLabel}</span>
      <span
        aria-hidden="true"
        className={`${checked ? "translate-x-full" : "translate-x-0"}
            pointer-events-none relative inline-block h-[14px] w-[14px] transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out`}
      >
        {iconRequired && (
          <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
            {checked ? (
              <CheckIcon className="h-[9px] w-[9px] text-themed-accent" />
            ) : (
              <XMarkIcon className="h-[9px] w-[9px] text-themed-textSecondary" />
            )}
          </span>
        )}
      </span>
    </HeadlessSwitch>
  );
}
